<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Kostick</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="kostikForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Datos de la pregunta</h3>
                        <hr>
                        <div class="row p-t-20">
                            <!--/span-->
                            <div class="row" formGroupName="opcA">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción A</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Serie</label>
                                        <select formControlName="value" class="form-control custom-select">
                                            <option value="n">N</option>
                                            <option value="a">A</option>
                                            <option value="p">P</option>
                                            <option value="x">X</option>
                                            <option value="b">B</option>
                                            <option value="o">O</option>
                                            <option value="z">Z</option>
                                            <option value="k">K</option>
                                            <option value="f">F</option>
                                            <option value="w">W</option>
                                            <option value="g">G</option>
                                            <option value="l">L</option>
                                            <option value="i">I</option>
                                            <option value="t">T</option>
                                            <option value="v">V</option>
                                            <option value="s">S</option>
                                            <option value="r">R</option>
                                            <option value="c">C</option>
                                            <option value="e">E</option>
                                            <option value="d">D</option>

    
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" formGroupName="opcB">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción B</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Serie</label>
                                        <select formControlName="value" class="form-control custom-select">
                                            <option value="n">N</option>
                                            <option value="a">A</option>
                                            <option value="p">P</option>
                                            <option value="x">X</option>
                                            <option value="b">B</option>
                                            <option value="o">O</option>
                                            <option value="z">Z</option>
                                            <option value="k">K</option>
                                            <option value="f">F</option>
                                            <option value="w">W</option>
                                            <option value="g">G</option>
                                            <option value="l">L</option>
                                            <option value="i">I</option>
                                            <option value="t">T</option>
                                            <option value="v">V</option>
                                            <option value="s">S</option>
                                            <option value="r">R</option>
                                            <option value="c">C</option>
                                            <option value="e">E</option>
                                            <option value="d">D</option>

    
                                        </select>
                                    </div>
                                </div>
                            </div>

 
                        
                    </div>
                </div>

                    <div class="form-actions">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Guardar</button>
                        <button type="button" class="btn btn-inverse" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>